import {
  DEFAULT_TABLE_PANEL_SHARED_FIELD_DATA,
  DrilldownTablePanelData,
} from 'features/drilldown/components/table/DrilldownTable'

export const DEFAULT_BLANK_TABLE_PANEL_DATA: DrilldownTablePanelData = {
  ...DEFAULT_TABLE_PANEL_SHARED_FIELD_DATA,
  title: 'Table',
  groupByType: 'unit',
  columns: [],
  isPinned: true,
  isConfigOpen: true,
}
